export default __webpack_public_path__ + "static/media/P2_Tip_Box.b9f40226.svg";